import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {CommonBuilderDataService} from "../../../../../../services/common-builder-data.service";

@Component({
    selector: 'db-add-page-btn',
    templateUrl: './add-page-btn.component.html',
    styleUrl: './add-page-btn.component.scss',
    standalone: false
})
export class AddPageBtnComponent {
  @Output() addPage: EventEmitter<void> = new EventEmitter<void>();
  @Input() openRight = true;
  @Input() opened = false;
  @Input() disabled = false;
  maxCount = inject(CommonBuilderDataService).secondaryPagesLimit;

  onAddPage() {
    if (this.disabled) {
      return;
    }
    this.addPage.emit();
  }
}
